import { render } from "./ButtonRecentOpportunities.vue?vue&type=template&id=fbd5ccee&scoped=true"
import script from "./ButtonRecentOpportunities.vue?vue&type=script&lang=js"
export * from "./ButtonRecentOpportunities.vue?vue&type=script&lang=js"

import "./ButtonRecentOpportunities.vue?vue&type=style&index=0&id=fbd5ccee&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-fbd5ccee"

export default script